/* import __COLOCATED_TEMPLATE__ from './market-date-time-select.hbs.js'; */
var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7;
function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
let MarketDateTimeSelect = (_class = class MarketDateTimeSelect extends Component {
  constructor(owner, args) {
    super(owner, args);
    _initializerDefineProperty(this, "localeTime", _descriptor, this);
    _initializerDefineProperty(this, "intl", _descriptor2, this);
    _initializerDefineProperty(this, "i18n", _descriptor3, this);
    _initializerDefineProperty(this, "startDate", _descriptor4, this);
    _initializerDefineProperty(this, "endDate", _descriptor5, this);
    _initializerDefineProperty(this, "isAllDay", _descriptor6, this);
    _initializerDefineProperty(this, "displayValue", _descriptor7, this);
    this.startDate = args.startDate;
    this.endDate = args.endDate;
    this.isAllDay = args.isAllDay || false;
    this.updateDisplayText();
  }
  get startDateString() {
    return this.startDate ? this.startDate.toISOString() : null;
  }
  get endDateString() {
    return this.endDate ? this.endDate.toISOString() : null;
  }
  isSameDate(startDate, endDate) {
    return startDate.getDate() === endDate.getDate() && startDate.getMonth() === endDate.getMonth() && startDate.getFullYear() === endDate.getFullYear();
  }
  generateDisplayDateTime(isAllDay) {
    if (!this.startDate) {
      // Not valid
      return '';
    }
    if (!this.endDate) {
      if (isAllDay) {
        return this.localeTime.dateTime(this.startDate, 'dateYearLast');
      } else {
        return this.i18n.t('sellerProjects.projectsList.endDateAndTime', {
          date: this.localeTime.dateTime(this.startDate, 'dateYearLast'),
          time: this.localeTime.dateTime(this.startDate, 'shortTime')
        });
      }
    }
    if (isAllDay) {
      if (this.isSameDate(this.startDate, this.endDate)) {
        // Same date, no times
        return this.localeTime.dateTime(this.startDate, 'dateYearLast');
      } else {
        // Different dates, no times
        return `${this.localeTime.dateTime(this.startDate, 'dateYearLast')} - ${this.localeTime.dateTime(this.endDate, 'dateYearLast')}`;
      }
    } else {
      if (this.isSameDate(this.startDate, this.endDate)) {
        // Same date, different times
        const timeRange = `${this.localeTime.dateTime(this.startDate, 'shortTime')} - ${this.localeTime.dateTime(this.endDate, 'shortTime')}`;
        return this.i18n.t('sellerProjects.projectsList.endDateAndTime', {
          date: this.localeTime.dateTime(this.startDate, 'dateYearLast'),
          time: timeRange
        });
      } else {
        // Different dates, different times
        return `${this.i18n.t('sellerProjects.projectsList.endDateAndTime', {
          date: this.localeTime.dateTime(this.startDate, 'dateYearLast'),
          time: this.localeTime.dateTime(this.startDate, 'shortTime')
        })} - ${this.i18n.t('sellerProjects.projectsList.endDateAndTime', {
          date: this.localeTime.dateTime(this.endDate, 'dateYearLast'),
          time: this.localeTime.dateTime(this.endDate, 'shortTime')
        })}`;
      }
    }
  }
  updateDisplayText() {
    this.displayValue = this.generateDisplayDateTime(this.isAllDay);
  }
  setTimeToNoonIfNewDate(date, prevDate) {
    if (date && !prevDate) {
      date.setHours(12);
      date.setMinutes(0);
    }
  }
  dateChanged() {
    this.updateDisplayText();
    this.args.onChange(this.isAllDay, this.startDate, this.endDate);
  }
  allDayCheckboxValueChange(checked) {
    this.isAllDay = checked;
    this.dateChanged();
  }
  marketDateRangeChanged(event) {
    const startDateString = event.detail.startDate;
    const endDateString = event.detail.endDate;

    // Set default start and end times to noon instead of the current time
    this.startDate = startDateString ? new Date(startDateString) : undefined;
    this.setTimeToNoonIfNewDate(this.startDate, event.detail.prevStartDate);
    this.endDate = endDateString ? new Date(endDateString) : undefined;
    this.setTimeToNoonIfNewDate(this.endDate, event.detail.prevEndDate);
    this.dateChanged();
  }
}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "localeTime", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "i18n", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "startDate", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "endDate", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "isAllDay", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "displayValue", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return '';
  }
}), _applyDecoratedDescriptor(_class.prototype, "allDayCheckboxValueChange", [action], Object.getOwnPropertyDescriptor(_class.prototype, "allDayCheckboxValueChange"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "marketDateRangeChanged", [action], Object.getOwnPropertyDescriptor(_class.prototype, "marketDateRangeChanged"), _class.prototype)), _class);
export { MarketDateTimeSelect as default };